import React from "react";
import { motion } from "framer-motion";
import { MapPin, ExternalLink } from "lucide-react";
import { useLang } from "../context/LanguageContext";

const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_eab8ba41-4926-4e2a-a9ee-abba0f452021/artifacts/c735de9w_f90bf017f73bbb035a838c122c2951eb95eae0d7d540193c1e53441de815cc11.png";

const MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=The+Barn+Gheorghieni+Feleacu+Cluj";

export default function Venue() {
  const { t } = useLang();

  return (
    <section
      id="venue"
      className="relative py-24 md:py-40 px-6 md:px-12 bg-cream/50"
      data-testid="venue-section"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.2 }}
          className="relative"
        >
          <div className="relative aspect-[4/3] w-full overflow-hidden rounded-sm">
            <img
              src={HERO_IMG}
              alt="The Barn"
              className="w-full h-full object-cover"
              data-testid="venue-image"
            />
            <div className="absolute inset-0 border border-wedding-border" />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.2, delay: 0.1 }}
        >
          <p className="text-xs uppercase tracking-[0.4em] text-burgundy mb-4">
            {t.venue.overline}
          </p>
          <h2 className="font-serif font-light text-5xl md:text-7xl text-ink mb-6">
            {t.venue.title}
          </h2>
          <div className="flex items-start gap-3 text-ink/75 mb-8">
            <MapPin size={18} className="text-burgundy mt-1 shrink-0" />
            <p
              className="font-serif italic text-lg md:text-xl leading-relaxed"
              data-testid="venue-address"
            >
              {t.venue.address}
            </p>
          </div>

          <a
            href={MAPS_URL}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-3 px-8 py-4 border border-burgundy text-burgundy rounded-full text-xs uppercase tracking-[0.3em] hover:bg-burgundy hover:text-ivory transition-colors duration-300"
            data-testid="venue-maps-button"
          >
            {t.venue.cta}
            <ExternalLink size={14} />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
